
export default function Navigation(){
    return(
             <nav className="white-bg">
        <div className="p-s pl-xxl txt-m ml-m">
          <a href="../../index.html">
            <span className="primary-color">Tweet</span>Social!
          </a>
        </div>
      </nav>
    )
}